<template>
  <div>
    <!--HERO IMAGE-->
    <section class="section-hero heroHeight section-shaped my-0 content">
      <div>
        <h1 class="text-hero">
          Fencing the country
          <div>
            since
            <span class="year">2007</span>
          </div>
        </h1>
      </div>
    </section>

    <!--Intro-->
    <section class="section section-lg" style="background-color: #eaeaea;">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 ml-5 intro">
            <h1>
              Get the <span>best</span> property <span>investment</span>
              options with the help of our highly experienced group of Engineers
              and Builders.
            </h1>
          </div>
          <div class="col-lg-5 ml-0 intro">
            <b-carousel controls indicators fade :interval="3000">
              <b-carousel-slide>
                <template v-slot:img>
                  <b-card no-body class="card-img-top img-fluid" img-src="img/carousel/optimized/carousel1.png"
                    style="border: none;" />
                </template>
              </b-carousel-slide>
              <b-carousel-slide>
                <template v-slot:img>
                  <b-card no-body class="card-img-top img-fluid" img-src="img/carousel/optimized/carousel2.png"
                    style="border: none;" />
                </template>
              </b-carousel-slide>
              <b-carousel-slide>
                <template v-slot:img>
                  <b-card no-body class="card-img-top img-fluid" img-src="img/carousel/optimized/carousel3.png"
                    style="border: none;" />
                </template>
              </b-carousel-slide>
              <b-carousel-slide>
                <template v-slot:img>
                  <b-card no-body class="card-img-top img-fluid" img-src="img/carousel/optimized/carousel4.png"
                    style="border: none;" />
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </section>

    <!-- Welcome Message -->
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-md-9">
            <h2 class="title">ABOUT US</h2>

            <router-link to="/about-us">
              <base-button class="mb-3 mb-sm-0 btn-outline-primary inquire" type="white">
                Learn More
              </base-button>
            </router-link>

            <p class="mt-4">
              Easyhomes, Inc. offers precast fences and other better alternative building systems that aim to create more
              value for clients through innovation, process efficiency, and product improvements.
            </p>
            <p>
              Incorporated in 2007, we are a precast fence company with more than 200,000 linear-meter fence installations
              under our belt. Our clients range from PPP-funded expressways, high-end residential developments, low-end
              housing projects, industrial plants, and warehouses to other projects that require the securing of
              properties.
            </p>
            <p>
              A member of the TAWI Group of Companies.
            </p>
          </div>
        </div>
      </div>

      <div class="container-fluid mt-4">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="row row-grid">
              <div class="text-center col-lg-4 col-md-4 col-sm-12 fcard">
                <router-link to="/our-projects">
                  <button class="container-fluid border-0 feature-card shadow p-3 mb-5 bg-white rounded feature-button"
                    style="text-align: center; cursor: pointer;" onclick="handleButtonClick()">
                    <i class="fa fa-cogs text-primary mb-3" style="font-size: 2.5rem;"></i>
                    <h6 class="text-primary text-uppercase">
                      HYBRID CONTRUCTION DESIGN
                    </h6>
                    <p class="description mt-3">
                      Easywall precast concrete fence combines the benefits of
                      pre-fabricated methodologies
                    </p>
                  </button>
                </router-link>
              </div>

              <div class="text-center col-lg-4 col-md-4 col-sm-12 fcard">
                <router-link to="/our-projects">
                  <button class="container-fluid border-0 feature-card shadow p-3 mb-5 bg-white rounded feature-button"
                    style="text-align: center; cursor: pointer;" onclick="handleButtonClick()">
                    <i class="fa fa-edit text-primary mb-3" style="font-size: 2.5rem;"></i>
                    <h6 class="text-primary text-uppercase">
                      CUSTOMIZATION OPTION
                    </h6>
                    <p class="description mt-3">
                      Provision of precast fence architectural options that
                      offer more value to clients.
                    </p>
                  </button>
                </router-link>
              </div>

              <div class="text-center col-lg-4 col-md-4 col-sm-12 fcard">
                <router-link to="/our-projects">
                  <button class="container-fluid border-0 feature-card shadow p-3 mb-5 bg-white rounded feature-button"
                    style="text-align: center; cursor: pointer;" onclick="handleButtonClick()">
                    <i class="fa fa-arrow-up text-primary mb-3" style="font-size: 2.5rem;"></i>
                    <h6 class="text-primary text-uppercase">
                      UPGRADABLE DESIGN
                    </h6>
                    <p class="description mt-3">
                      Design variation from standard precast fence can be
                      accommodated.
                    </p>
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--WHY PARTNER WITH US-->
    <section class="section section-lg" style="background-color: #eaeaea;">
      <div class=" text-center">
        <h1 class="title">WHY PARTNER WITH US</h1>
        <div class="container container-wpwu">
          <div class="row">
            <div class="col-lg-2 col-md-5 col-sm-12 my-2 mx-1 box">
              <h1 class="text justify-content-center text-center">15+</h1>
              <h6 class="desc justify-content-center text-center">
                15+ years experience in the industry
              </h6>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 my-2 mx-1 box">
              <h1 class="text justify-content-center text-center">200,000</h1>
              <h6 class="desc justify-content-center text-center">
                With more than 200,000 linear meter fence installations under
                our belt.
              </h6>
            </div>
            <div class="col-lg-3 col-md-5 col-sm-12 my-2 mx-1 box">
              <h1 class="text justify-content-center text-center">24</h1>
              <h6 class="desc justify-content-center text-center">
                Awarded by the Intellectual Property Office of the Philippines
                (IPOPH) as Most Number of Patents Filed 1998-2017 with 24
                patents.
              </h6>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 my-2 mx-1 box">
              <h1 class="text justify-content-center text-center">4,000</h1>
              <h6 class="desc justify-content-center text-center">
                Flexible manufacturing capacity: 4,000lm/month production can be
                doubled within 3 months.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--OUR PRODUCTS-->
    <section class="section section-lg">
      <div class="container-fluid text-center">
        <h1 class="title mb-5">OUR PRODUCTS</h1>

        <div class="container container-op">
          <div class="row form-group">
            <!-- precast fence -->
            <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
              <div class="hover hover-4 text-white rounded mx-2">
                <img class="img-fluid" src="img/products/home/fencing.png" alt="img" />
                <div class="hover-overlay" />
                <div>
                  <p class="hover-4-description text-uppercase mb-0 small" style="color: #000000;">
                    <span class="font-weight-bold" style="color: #000000;">
                      A. Standard Fencing
                    </span>
                    <br />
                    A cost-effective alternative to brick or stone masonry fences.
                    <br />
                    <br />
                    <span class="font-weight-bold" style="color: #000000;">
                      B. Hybrid CHB
                    </span>
                    <br />
                    Can withstand windload up to 150.343 mph to 250 kph
                  </p>
                </div>
              </div>
            </div>

            <!-- housing fence -->
            <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
              <div class="hover hover-4 text-white rounded mx-2">
                <img class="img-fluid" src="img/products/home/housing.png" alt="img" />
                <div class="hover-overlay" />
                <div>
                  <p class="hover-4-description font-weight-bold text-uppercase mb-0 small"
                    style="font-size: 20px; color: white;">
                    UNDER DEVELOPMENT
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <!--Precast concrete fence expert-->
    <section class="heroHeight2 my-0">
      <img src="/img/background/optimized/precast3.png" class="img-fluid"
        style="width: auto; height: auto; object-fit: cover;" alt="precast" />
    </section>

    <!--OUR CLIENTS-->
    <section class="section section-lg cs">
      <h1 class="title my-5">
        OUR CLIENTS
      </h1>

      <h6 class="desc justify-content-center text-center mb-5 mx-4">
        Here are some of the industries we are proud to serve throughout the Philippines.
      </h6>

      <div class="container carousel-clients">
        <b-carousel fade :interval="1000">
          <b-carousel-slide v-for="(client, index) in clients" :key="index">
            <template #img>
              <div>
                <b-card no-body class="img-fluid" style="border: none;">
                  <img :src="client.image.url" :title="client.clientName" class="img-fluid"
                    style="height: 200px; width: 200px;" alt="no image" />
                </b-card>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>

      <div class="container normal-clients">
        <div class="row text-center mb-5">
          <!-- First Column -->
          <div class="col-6 col-md-6 col-lg-6">
            <div class="row">
              <div v-for="(client, index) in clients.slice(0, 12)" :key="index" class="col-6 col-md-3 px-1 mb-1">
                <img :src="client.image.url" :title="client.clientName" class="img-fluid" alt="client"
                  style="height: 100px; width: 100px;" />
              </div>
            </div>
          </div>
          <!-- Second Column -->
          <div class="col-6 col-md-6 col-lg-6">
            <div class="row">
              <div v-for="(client, index) in clients.slice(12, clients.length)" :key="index"
                class="col-6 col-md-3 px-1 mb-1">
                <img :src="client.image.url" :title="client.clientName" class="img-fluid" alt="client"
                  style="height: 100px; width: 100px;" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import clientDAO from '../database/clients'
import { BCarousel } from 'bootstrap-vue/esm/components/carousel/carousel'
import { BCarouselSlide } from 'bootstrap-vue/esm/components/carousel/carousel-slide'
import { BCardGroup } from 'bootstrap-vue/esm/components/card/card-group'
import { BCard } from 'bootstrap-vue/esm/components/card/card'

export default {
  name: 'home',
  components: {
    BCarousel,
    BCarouselSlide,
    BCardGroup,
    BCard,
  },

  data() {
    return {
      clients: [],
    }
  },
  created() {
    this.retrieveAll()
  },
  methods: {
    async retrieveAll() {
      try {
        const data = await clientDAO.retrieveActive()
        this.clients = data
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins');

.title {
  color: #56594d;
  font-weight: 600;
  font-size: 3rem;
  text-align: center;
}

h1{
  font-weight: bold !important;
}
h2{
  font-weight: bold !important;
}
.heroHeight {
  background-image: url('/img/background/optimized/hero-image-try2.png');
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.feature-card {
  min-height: 250px;
  max-height: 250px;
  max-width: 650px;
  min-width: 250px;
}

span {
  color: rgb(255, 187, 0);
}

.text-hero {
  color: white;
  position: absolute;
  bottom: 3rem;
  left: 5rem;
  font-size: 5rem;
  font-weight: 800;
  line-height: 85px;
  letter-spacing: -4px;
  text-shadow: 2px 2px 5px rgb(30, 29, 29);
}

.intro {
  display: block;
  margin: auto;
}

.intro h1 {
  margin-top: 7px;
  font-size: 45px;
  padding: 0px 40px 0 30px;
  margin-right: 35px;
  color: black;
  font-weight: 500;
  letter-spacing: 1px;
}

.intro h1 span {
  color: rgb(255, 187, 0);
}

.carousel-clients {
  display: none;
}

.text {
  color: #56594d;
  font-size: 3rem;
  font-weight: 600;
}

.desc {
  color: #56594d;
  font-size: 1.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.box {
  border-top: 1px solid #56594d;
  padding-top: 1rem;
  margin-top: 1rem;
}

.rows {
  flex-wrap: nowrap;
  justify-content: center;
}

.container-wpwu {
  margin-top: 120px;
}

.form-group {
  margin-right: -8rem;
  margin-left: -8rem;
}

.hover-4 img {
  position: relative;
  height: auto;
  width: 100%;
  /* display: flex; */
  /* margin: auto; */
  object-fit: contain;
  top: 0;
  left: 0;
  border-radius: 25px 25px 25px 0;
}

/* hover effect */
.hover-4 .hover-overlay {
  background: rgba(0, 0, 0, 0.4);
  z-index: 90;
}

.hover-4-description {
  position: absolute;
  top: 5rem;
  left: 6rem;
  background-color: #eda71185;
  text-align: right;
  border-right: 3px solid #fff;
  border-radius: 10px;
  padding: 10px 1rem;
  z-index: 99;
  transform: translateX(-1.5rem);
  opacity: 0;
  transition: all 0.3s;
}

.hover-4:hover::after {
  opacity: 1;
  transform: none;
}

.hover-4:hover .hover-4-description {
  opacity: 1;
  transform: none;
}

.hover-4:hover .hover-overlay {
  background: rgba(0, 0, 0, 0.8);
}

/* galaxy fold */
@media only screen and (max-width: 280px) {
  .heroHeight {
    height: 100vh;
  }

  .heroHeight2 {
    height: 100vh;
  }

  .container-op {
    width: 75% !important;
  }

  .hover-4-description {
    top: 1rem !important;
    left: 2rem !important;
    width: 80% !important;
  }

  .client {
    font-size: 2rem;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .heroHeight {
    height: 87vh;
  }

  .text-hero {
    bottom: 2rem;
    left: 1rem;
    font-size: 2rem;
    line-height: 55px;
    letter-spacing: 0px;
  }

  .container-op {
    width: 80%;
  }

  .title {
    margin-left: 0;
    font-size: 25px;
    margin-top: -45px;
  }

  .intro h1 {
    margin-top: 7px;
    font-size: 24px;
    padding: 0px 0px 23px 0px;
    margin-left: -35px;
    color: black;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .fcard {
    margin-bottom: -70px;
  }

  .rows {
    flex-wrap: wrap;
    justify-content: center;
  }

  .shape {
    width: 15rem;
    height: 8rem;
    bottom: 33px;
    left: 109px;
  }

  .shape p {
    line-height: 16px;
    font-size: 13px;
  }

  .cs {
    padding-top: 0px;
  }

  .hover-4-description {
    top: 3rem;
    left: 3rem;
    width: 80%;
  }

  .carousel-clients {
    display: flex !important;
    justify-content: center;
  }

  .normal-clients {
    display: none;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  /* .heroHeight {
      height: 100vh;
    } */

  /* .heroHeight2 {
      height: 100vh;
    } */

  .desc {
    font-size: 1rem;
  }

  .container-wpwu {
    width: 95%;
  }

  .container-op {
    width: 80%;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .heroHeight {
    background-size: contain;
    background-position: top;
    height: 40vh !important;
  }

  /* .heroHeight2 {
      background-size: contain;
      height: 40vh !important;
    } */

  .feature-card {
    min-width: 225px;
  }

  .text-hero {
    top: 17rem;
    left: 3rem;
    font-size: 3rem;
    line-height: 55px;
    letter-spacing: -1px;
  }

  .intro h1 {
    font-size: 43px;
    padding: 0px 40px 44px 45px;
    margin: auto;
    color: black;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .hover-4-description {
    top: 0.5rem;
    left: 2rem;
    width: 80%;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .hover-4-description {
    width: 50%;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {}
</style>
